import { createSelector } from '@reduxjs/toolkit';

export const notificationsSelector = ({ notifications }: any) => notifications;
const extractWorkspaceId = (_: any, workspaceId: string) => workspaceId;
const extractChannelId = (_: any, __: any, channelId: string) => channelId;

export const notificationsWorkspaceSelector = () =>
  createSelector(
    notificationsSelector,
    extractWorkspaceId,
    (notifications, propKey) => notifications?.[propKey],
  );

export const selectChannelBadges = () =>
  createSelector(
    notificationsSelector,
    extractWorkspaceId,
    extractChannelId,
    (notifications, workspaceId, channelId) =>
      notifications?.[workspaceId]?.channelNotifications?.[channelId]?.badge,
  );
